import AppGalleryBadge from './AppGalleryBadge.png'
import PlayStoreBadge from './PlayStoreBadge.png'
import AppStoreBadge from './AppStoreBadge.png'

export default {
  APPLE: AppStoreBadge,
  GOOGLE: PlayStoreBadge,
  HUAWEI: AppGalleryBadge,
}
